export default __webpack_public_path__ + "static/media/opening.994fd552.png";